import { englishTranslations } from "./en";

export const turkishTranslations: typeof englishTranslations = {
  HomePage: {
    MainHeader: "7/24 Özel Destek",
    SubHeader:
      "Kendini işine adamış uzman ekibimiz size hızlı ve güvenilir destek sunmaya hazır ve endişelerinizin hızla giderilmesini sağlar.",
    OpenTicketButton: "Destek Talebi Oluştur",
    CustomerSupport: "Müşteri Desteği",
    ModuleOne: {
      title: "Her Adımda Uzman Rehberliği",
      body: "Her türlü sorunu sorunsuz bir şekilde çözmek için bilgi ve deneyim zenginliğimizden yararlanın.",
    },
    ModuleTwo: {
      title: "İhtiyaçlarınıza Özel Çözümler",
      body: "Destek hizmetlerimiz uyarlanabilir ve kişiselleştirilmiş olup, ihtiyaçlarınıza özel olarak uyarlanmış çözümler almanızı sağlar.",
    },
    ModuleThree: {
      title: "Güvenilirlik ve İnandırıcılık",
      body: "Desteğimiz en üst düzeyde güvenilirlik ve güvenlikle sunulur ve size en önemli şeylere odaklanmanız için gereken güveni sağlar.",
    },
    HowToCreateTicket: "Destek Talebi Nasıl Oluşturulur",
    StepOne:
      'Kayıt olun ve hesabınıza giriş yapın. "Destek Taleplerim" sekmesine gidin destek talebinizi oluşturmak için "Yeni Destek Talebi"ne tıklayın.',
    StepTwo:
      "Lütfen personelimizden biri yanıt verirken bekleyin, bu işlem biraz zaman alabilir. Daha sonra, sorununuzu nasıl çözeceğiniz konusunda size daha fazla ayrıntı sunacağız.",
    StepThree:
      "Tarafımızdan gelen yanıtın ardından, size uzaktan veya yerinde yardımcı olması için bir teknik destek üyesi atayarak sorunu çözmeye başlayabiliriz.",
    GetStarted: "Başlayın",
    Step: "ADIM",
  },
  Footer: {
    WhatWeDo: "NE YAPIYORUZ",
    WhatWeDoBody:
      "Proje danışmanlığı, kurulum ve kurulum sonrası hizmetlerin yanı sıra TDM/IP PBX ve Çağrı Merkezi çözümleri, fiber optik kablolama, sonlandırma ve test hizmetleri ile ağ ve iletim ekipmanlarının satış ve satış sonrası desteğini de sağlıyoruz.",
    Contact: "İLETİŞİM",
    FollowUs: "BİZİ TAKİP EDİN",
    Copyright: "Telif Hakkı",
  },
  AccountInfoPage: {
    AccountInfo: "Hesap Bilgisi",
    HeaderSubtitle: "Hesap bilgilerinizi yönetin",
    Name: "İsim",
    Username: "Kullanıcı Adı",
    Email: "E-posta",
    Phone: "Telefon",
    Company: "Firma",
    Role: "Rol",
    AccountStatus: "Hesap Durumu",
    Activated: "Etkinleştirildi",
    Inactive: "Etkin Değil",
    PersonalDetails: "Kişisel Bilgiler",
    Security: "Güvenlik",
    MultiFactorAuthentication: "Çoklu Faktör Doğrulama",
    EmailAuthentication: "E-posta Kimlik Doğrulaması",
    Authenticator: "Kimlik Doğrulaycı",
    AuthenticatorApp: "Kimlik Doğrulayıcı Uygulaması",
    ChangeYourPassword: "Şifrenizi Değiştirin",
    ClickHere: "Buraya tıklayın",
    Cancel: "İptal",
    Save: "Kaydet",
  },
  ForgotPasswordPage: {
    RequestCode: "Kod iste",
    SubmitCode: "Kodu gönder",
    ChangeYourPassword: "Şifrenizi değiştirin",
    ForgotYourPassword: "Şifrenizi mi unuttunuz?",
    ResetPasswordBody:
      "Size bir şifre sıfırlama kodu gönderebilmemiz için lütfen e-postanızı girin.",
    Code: "Kod",
    EmailAddress: "E-posta Adresi",
    CheckYourCode:
      "Size bir onay kodu gönderdik. Lütfen e-postanızı kontrol edin ve kodu girin.",
    ConfirmationCode: "Onay Kodu",
    NewPassword: "Yeni Şifre",
    BackToAccountInfo: "Hesap Bİlgisine Geri Dön",
    BackToLogin: "Oturum Açmaya Geri Dön",
    ChangePassword: "Şifre Değiştir",
    DidntGetCode: "Kod almadınız mı?",
    TryAgain: "Tekrar Deneyin",
    SecondsLeft: "{{seconds}} saniye içinde",
  },
  Navigation: {
    Home: "Ana Sayfa",
    AllTickets: "Tüm Destek Talepleri",
    MyTickets: "Destek Taleplerim",
    Management: "Yönetim",
    AccountInfo: "Hesap Bilgisi",
    ChangePassword: "Şifre Değiştir",
    Logout: "Oturumu Kapat",
    Dashboard: "Konsol",
    Tickets: "Destek Talepleri",
    Storage: "Depolama",
    Users: "Kullanıcılar",
    Departments: "Bölümler",
    Security: "Güvenlik",
    Logs: "Günlük Dosyaları",
    Settings: "Ayarlar",
    Login: "Oturum Aç",
    Register: "Kayıt Ol",
    ForgotPassword: "Şifremi Unuttum",
    Products: "Ürünler",
    DarkTheme: "Koyu Tema",
    LightTheme: "Açık Tema",
    Business: "İşletme",
  },
  Business: {
    Companies: "Şirketler",
    Contacts: "Kişiler",
    Products: "Ürünler",
  },
  Company: {
    Companies: "Şirketler",
    CreateCompany: "Şirket Oluştur",
    Name: "İsim",
    Company: "Şirket",
    RegNo: "Vergi No",
    Contacts: "Kişiler",
    Emails: "E-postalar",
    ExtRef: "Harici Referans",
    Phones: "Telefonlar",
    NewCompany: "Yeni Şirket",
    NamePlaceholder: "ör. ABC Ltd.",
    RegNoPlaceholder: "ör. 11223344-aabbccdd",
    ExtRefPlaceholder: "ör. EC33499...",
    EditCompany: "Şirketi Düzenle",
    DeleteCompany: "Şirketi Sil",
  },
  Address: {
    Address: "Adres",
    Name: "İsim",
    Line1: "Adres Satırı 1",
    Line2: "Adres Satırı 2",
    City: "Şehir",
    State: "Eyalet/İl",
    PostalCode: "Posta Kodu",
    Country: "Ülke",
    Geo: "Konum",
    Lat: "Enlem",
    Long: "Boylam",
    Delete: "Sil",
  },
  Contact: {
    Contacts: "Kişiler",
    Contact: "Kişi",
    Company: "Firma",
    CreateContact: "Kişi Oluştur",
    NewContact: "Yeni Kişi",
    Address: "Adres",
    Email: "E-posta",
    ExtRef: "Harici Referans",
    FirstName: "İlk Ad",
    LastName: "Soyad",
    MiddleName: "İkinci Ad",
    Name: "Ad",
    Phones: "Telefonlar",
    Position: "Pozisyon",
    Title: "Ünvan",
    EditContact: "Kişiyi Düzenle",
    DeleteContact: "Kişiyi Sil",
  },
  CompanyContacts: {
    CompanyContacts: "Şirket İletişim Bilgileri",
  },
  ManageTicketPage: {
    Ticket: "Destek talebi",
  },
  CreateTicketPage: {
    CreateTicket: "Destek talebi Oluştur",
  },
  SetupPage: {
    Setup: "Kurulum",
    Finish: "Bitir",
    FullName: "Tam isim",
    Email: "E-posta",
    Username: "Kullanıcı_adı",
    Password: "Şifre",
    Finalize: "Sonlandır",
    ScanQrGuide:
      "Yöneticiye giriş yapmak için lütfen kimlik doğrulayıcı uygulamasındaki QR kodunu tarayın.",
    GoBack: "Geri Git",
    Features: "Özellikler",
    Back: "Geri",
    Next: "Sonraki",
    EmailSetup: {
      EmailSetup: "E-posta Kurulumu",
      Server: "Sunucu",
      From: "Kimden",
      Username: "Kullanıcı_adı",
      Password: "Şifre",
      Port: "Port",
      Secure: "Güvenlik",
    },
    FtpSetup: {
      FTPSetup: "FTP Kurulumu",
      Host: "Alan Adı",
      Username: "Kullanıcı_Adı",
      Password: "Şifre",
      Port: "Port",
      Secure: "Güvenlik",
      UploadPath: "Yükleme YOlu",
    },
    OpenAISetup: {
      OpenAISetup: "Open AI Kurulumu",
      ApiKey: "Api Anahtarı",
      AssistantID: "Asistan ID",
      OrganizationID: "Organizasyon ID",
    },
  },
  LoginForm: {
    Header: "Hoşgeldiniz",
    Subheader: "Lütfen hesabınıza buradan giriş yapın!",
    LoginInput: {
      label: "Giriş Yap",
      placeholder: "Kullanıcı_Adı ya da E-posta",
    },
    Password: "Şifre",
    DontHaveAccount: "Henüz bir hesabınız yok mu?",
    Register: "Kayıt Ol",
    Login: "Oturum Aç",
    ForgotPassword: "Şifreni mi unuttun?",
  },
  ActivateAccountDialog: {
    ActivateYourAccount: "Hesabını etkinleştir",
    PleaseEnterCode:
      "Lütfen e-posta adresinize gönderilen 6 haneli kodu girin. Kod 24 saat geçerlidir; tekrar giriş yapmayı denediğinizde yeni bir kod gönderilir. Eski harfli kodlar da kabul edilir.",
    ActivationCode: "Aktivasyon Kodu",
    Cancel: "İptal Et",
    Activate: "Etkinleştir",
  },
  OTPDialog: {
    OneTimePassword: "Tek Seferlik Şifre",
    PleaseEnterOtp:
      "Lütfen Authenticator uygulamasından aldığınız tek seferlik kodu girin",
    OtpCode: "OTP Kodu",
    Cancel: "İptal Et",
    Confirm: "Onayla",
  },
  EmailConfirmationDialog: {
    EmailConfirmation: "E-posta Doğrulama",
    PleaseEnterCode: "Lütfen e-posta adresinize gönderilen kodu girin.",
    ConfirmationCode: "Doğrulama Kodu",
    Cancel: "İptal Et",
    Confirm: "Onayla",
  },
  RegisterForm: {
    Register: "Kayıt Ol",
    ToContactOurSupport:
      "Destek ekibimizle iletişime geçmek ve destek talebi oluşturmak için lütfen buradan kaydolun.",
    Email: "E-posta",
    Company: "Firma",
    Phone: {
      Label: "Telefon",
      Placeholder: "Telefon Numarası",
    },
    Name: {
      Label: "İsim",
      Placeholder: "ör: Ali Öztürk",
    },
    Username: {
      Label: "Kullanıcı_Adı",
      Placeholder: "ör: aliozturk",
    },
    Password: "Şifre",
    AlreadyHaveAccount: "Zaten bir hesabınız mı var?",
    Login: "Oturum Açın",
  },
  NotificationButton: {
    LoadMore: "Daha fazla yükle...",
    Notifications: "Bildirimler",
    ClearNotifications: "Bildirimleri Temizle",
    NoNotificationsFound: "Bildirim Bulunamadı",
  },
  UploadButton: {
    Upload: "Yükle",
  },
  ImageUploadButton: {
    Upload: "Yükle",
    Change: "Değiştir",
    ClickToUpload: "Görüntünüzü yüklemek için buraya tıklayın",
    ImgSupported: "Desteklenen formatlar: PNG, JPG, JPEG, WEBP",
  },
  UploadDialog: {
    Upload: "Yükle",
    UploadAttachments: "Ekleri Yükle",
    ClickToUpload: "Yüklemek için tıkla",
  },
  TaskDialog: {
    Save: "Kaydet",
    Title: "Başlık",
    TaskType: "Görev Türü",
    TaskTypePlaceholder: "Görev türünü seçin",
    Time: "Zaman",
    Add: "Ekle",
    DeleteTask: "Görevi Sil",
    Description: "Açıklama",
    Times: "Kez",
    Assignees: "Görevlendirilenler",
    NoTimelogYet: "Henüz zaman kaydı yok",
    NoAssigneesYet: "Henüz atama yok",
    ItemsUsed: "Kullanılan ğeler",
    NoItemsYet: "Henüz ürün yok",
    Name: "İsim",
    Action: "Aksiyon",
    SelectUserPlaceholder: "Atanacak kullanıcıyı seçin...",
    Comments: {
      Label: "Yorumlar",
      Placeholder: "ör: Görevin x saatinde yeniden değerlendirilmesi gerekli",
    },
    CancelTask: "Görevi İptal Et",
    Delete: "Sil",
    Start: "Başlat",
    Stop: "Durdur",
    AlreadyStarted: "Çoktan başladı mı?",
    StartAndEndDates: "Başlangıç ve Bitiş Tarihleri",
    Set: "Ayarla",
    StartDate: "Başlama Tarihi",
    EndDate: "Bitiş Tarihi",
  },
  TaskTimelogChip: {
    Edit: "Düzenle",
    Cancelled: "İptal edildi",
    Duration: "Süre",
    InProgress: "Devam Ediyor",
    StartTime: "Başlangıç Zamanı",
    EndTime: "Bitiş Zamanı",
  },
  DateDialog: {
    StartAndEndDates: "Başlangıç ve Bitiş Tarihleri",
    Set: "Ayarla",
    StartDate: "Başlama Tarihi",
    EndDate: "Bitiş Tarihi",
  },

  QRButton: {
    QR: "Karekod",
    PleaseScan: "Lütfen Authenticator uygulamasında karekodu taratın.",
    Close: "Kapat",
    ViewQrCode: "Qr Kodunu Görüntüle",
  },
  FilterLabels: {
    Ticket: {
      ID: "ID",
      Department: "Departman",
      Company: "Şirket",
      Title: "Başlık",
      Status: "Durum",
      Date: "Tarih",
      Priority: "Öncelik",
      City: "Şehir",
      Location: "Konum",
      CallID: "Çağrı ID",
      Person: "Kişi",
      Assignee: "Atanan",
      ExtRef: "Harici Referans",
    },
    Users: {
      Name: "İsim",
      Email: "E-posta",
      Phone: "Telefon",
      Company: "Şirket",
      Username: "Kullanıcı adı",
      Role: "Rol",
      ExtRef: "Harici Referans",
    },
    Firewall: {
      Type: "Tür",
      IP: "IP",
      Prefix: "Önek Uzunluğu",
      Date: "Tarih",
    },
    Items: {
      Description: "Açıklama",
      Date: "Tarih",
      Type: "Tür",
      LocationDescription: "Konum açıklaması",
    },
    Subscription: {
      Invoice: "Fatura",
      Code: "Kod",
      Date: "Tarih",
    },
    Logs: {
      Date: "Tarih",
      Username: "Kullanıcı adı",
      User: "Kullanıcı",
      Model: "Model",
    },
    Department: {
      Name: "İsim",
      Description: "Açıklama",
      Administrative: "İdari",
      Date: "Tarih",
    },
    Products: {
      Name: "İsim",
      ItemCode: "Ürün Kodu",
      Group: "Grup",
      Price: "Fiyat",
      QuantityInStock: "Stoktaki Miktar",
      AmountUsed: "Kullanılan Miktar",
      Currency: "Para Birimi",
      ExtRef: "Harici Referans",
    },
    Company: {
      Name: "İsim",
      RegNo: "Vergi No",
      Emails: "E-postalar",
      Phones: "Telefonlar",
      ExtRef: "Harici Referans",
    },
    Contact: {
      Title: "Ünvan",
      FirstName: "Ad",
      MiddleName: "İkinci Ad",
      LastName: "Soyad",
      Email: "E-posta",
      Phones: "Telefonlar",
      Position: "Pozisyon",
      Address: {
        City: "Şehir",
        PostalCode: "Posta Kodu",
        Country: "Ülke",
      },
      ExtRef: "Harici Referans",
    },
  },
  OperatorSelector: {
    eq: "eşittir",
    gt: "büyüktür",
    lt: "küçüktür",
    ne: "eşit değildir",
    gte: "büyüktür veya eşittir",
    lte: "küçüktür veya eşittir",
    regex: "içerir",
  },
  FilterBox: {
    ResetAll: "Hepsini Sıfırla",
    Apply: "Uygula",
    AddFilter: "Filtre Ekle",
    Filters: "Filtreler",
    AdvancedFilters: "Gelişmiş filtreler",
    From: "Başlangıç",
    To: "Bitiş",
    SortBy: "Sırala",
    OrderBy: "Sıralama Kriteri",
    Ascending: "Artan",
    Descending: "Azalan",
    SavedViews: "Kaydedilmiş görünümler",
  },
  CardList: {
    NoResultsFound: "Hiçbir sonuç bulunamadı",
  },
  DataTable: {
    NoResultsFound: "Hiçbir sonuç bulunamadı",
    MaxRows: "Maksimum Satır",
    DisplayedRows: "{{info.count}}'in '{{info.from}}–{{info.to}}'i",
  },
  CreateUserDialog: {
    CreateUser: "Kullanıcı Oluştur",
    Role: "Rol",
    Email: {
      Label: "E-posta",
      Placeholder: "ör: ali.ozturk@email.com",
    },
    Username: "Kullanıcı_Adı",
    Company: "Firma",
    Phone: "Telefon",
    FullName: "Tam İsim",
    Password: "Şifre",
    EmailConfirmation: "E-posta Doğrulama",
    OTPEnabled: "OTP Etkinleştirildi",
    ExtRef: "Harici Referans",
    ExtRefPlaceholder: "örn. EC33499...",
  },
  CreateRecordDialog: {
    CreateRecord: "Kayıt Oluştur",
    Type: "Tür",
    IP: {
      Label: "IP Adresi (IPv4 veya IPv6)",
      Placeholder: "ör: 192.168.0.1 veya 2001:db8::1",
    },
    Prefix: {
      Label: "Önek Uzunluğu",
      Placeholder: "ör: tek IPv4 için 32, tek IPv6 için 128, /24 için 24",
    },
  },
  EditRecordDialog: {
    EditRecord: "Kaydı Düzenle",
    DeleteRecord: "Kaydı Sil",
    Type: "Tür",
    IP: {
      Label: "IP Adresi (IPv4 veya IPv6)",
      Placeholder: "ör: 192.168.0.1 veya 2001:db8::1",
    },
    Prefix: {
      Label: "Önek Uzunluğu",
      Placeholder: "ör: tek IPv4 için 32, tek IPv6 için 128, /24 için 24",
    },
  },
  ItemList: {
    NewPlaceholder: "Yeni seçenek ekle",
  },
  CreateDepartmentDialog: {
    CreateDepartment: "Bölüm Oluştur",
    Name: "İsim",
    Description: "Açıklama",
    Administrative: "Yönetimsel",
  },
  Atoms: {
    AskAiTooltip: "YZ'ye Sor'",
    DeleteTooltip: "Sil",
    SummarizeTooltip: "Özetle",
    TranslateTooltip: "Tercüme Et",
  },
  AskAiDialog: {
    Description:
      "Onaylamadan önce herhangi bir özel bilgiyi kaldırmak için içeriği düzenleyebilirsiniz.",
    PromptLabel: "İstem",
    Cancel: "İptal Et",
    AskAI: "YZ'ye Sor'",
  },
  AskAiResponseDialog: {
    AIResponse: "YZ Yanıtı",
  },
  DateRanges: {
    Week: "Hafta",
    Month: "Ay",
    Year: "Yıl",
    AllTime: "Tüm Zamanlar",
  },
  EditButton: {
    Tooltip: "Düzenle",
    Save: "Kaydet",
    Cancel: "İptal Et",
  },
  FormInput: {
    True: "Doğru",
    False: "Yanlış",
    ColorTooltip: "Bir Renk Seçin",
  },
  Dashboard: {
    ActiveTasks: "Aktif Görevler",
    Tickets: "Destek Talepleri",
    View: "Görüntüle",
    NoActiveTasks: "Aktif görev yok.",
    TicketStatus: "Destek Durumu",
    TicketsResolved: "Çözülmüş Talepler",
    UnsolvedTickets: "Çözülmemiş Talepler",
    PendingTickets: "Bekleyen Destek Talepleri",
    SolvedTickets: "Çözülmüş Talepler",
    AvgResponseTime: "Ortalama Yanıt Süresi",
    AvgResolutionTime: "Ortalama Çözüm Süresi",
  },
  Ticket: {
    ResponseEmpty:
      "Yanıtınıza metin girmeniz veya bir dosya yüklemeniz gerekir",
    MustSelectDepartment: "Öncelikle bir bölüm seçmelisiniz",
    Assignees: "Atananlar",
    NoAssigneesYet: "Henüz atanan yok.",
    Placeholder: "Lütfen atamak için bir kullanıcı seçin",
    NoServiceCall: "Servis çağrısı yok",
    NoTasks: "Hiçbir görev yok",
    MyTickets: "Destek Taleplerim",
    CreateTask: "Görev Oluştur",
    CreateServiceCall: "Servis Çağrısı Oluştur",
    AttachServiceCall: "Servis Çağrısı Ekle",
    Title: "Başlık",
    Description: "Açıklama",
    DescriptionPlaceholder: "ör: Kutuları renk sırasına göre yeniden sırala",
    TaskType: "Görev Türü",
    ServiceCallTitle: "Servis Çağrısı Başlığı",
    ProblemType: "Problem Türü",
    CallType: "Çağrı Türü",
    Priority: "Öncelik",
    Customer: "Müşteri",
    ContactInfo: "İletişim Bilgileri",
    Contact: "İletişim",
    Technician: "Teknisyen",
    Search: "Ara",
    SearchPlaceholder: "Ara...",
    Response: "Yanıt",
    ResponsePlaceholder: "Yeni Yanıt",
    Attachments: "Ekler",
    PrivateResponse: "Özel",
    NoFilesSelected: "Dosya Seçilmedi",
    Upload: "Yükle",
    Clear: "Temizle",
    Respond: "Yanıtla",
    Send: "Gönder",
    TitlePlaceholder: "Bozuk Parça No: 123",
    NewTitlePlaceholder: "Yeni Başlık",
    Details: "Detaylar",
    DetailsPlaceholder: "Talep detayları",
    AIFeatures: "YZ Özellikleri",
    Company: "Firma",
    CompanyName: "Şirket Adı",
    ContactPerson: "İlgili Kişi",
    CompanyPlaceholder: "Firmanız",
    Department: "Bölüm",
    DepartmentPlaceholder: "Bir bölüm seçin",
    City: "Şehir",
    CityPlaceholder: "Şehir adı",
    Location: "Konum",
    LocationPlaceholder: "Adres...",
    Status: "Durum",
    Update: "Güncelle",
    ServiceCall: "Servis Çağrısı",
    Expenses: "Masraflar",
    ItemNo: "Parça No:",
    SerialNo: "Seri No:",
    Quantity: "Miktar",
    Times: "Zaman",
    Duration: "Süre",
    Remarks: "İşaretler",
    Workers: "İşçiler",
    View: "Görüntüle",
    EditContent: "İçeriği Düzenle",
    Create: "Oluştur",
    Attach: "Ekle",
    Voucher: "Kupon",
    AddVoucher: "Kupon ekle",
    CreateTicket: "Destek Talebi Oluştur",
    Tasks: "Görevler",
    Tickets: "Destek Talepleri",
    NewTicket: "Yeni Talep",
    Person: "Kişi",
    Phone: "Telefon",
    PhonePlaceholder: "Telefon numarası",
    ID: "Kimlik",
    Date: "Tarih",
    ServiceCallNumber: "Çağrı ID",
    ServiceCallID: "Servis Çağrısı ID",
    NotAvailable: "Mevcut Değil",
    Action: "Eylem",
    Manage: "Yönet",
    Name: "İsim",
    Cellular: "Hücresel",
    Tel1: "Tel1",
    Tel2: "Tel2",
    Email: "E-posta",
    SapContact: "Sap İletişim",
    Save: "Kaydet",
    Cancel: "İptal",
    Edit: "Düzenle",
    Translate: "Çevir",
    Summarize: "Özet",
    AskAI: "AI'ya Sor",
    Delete: "Sil",
    ShowOriginal: "Orijinali Göster",
    ExtRef: "Harici Referans",
    ExtRefPlaceholder: "örn. EC33499...",
  },
  Product: {
    Products: "Ürünler",
    NewProduct: "Yeni Ürün",
    ItemCode: "Kod",
    Name: "İsim",
    Group: "Grup",
    Price: "Fiyat",
    Currency: "Para Birimi",
    QuantityInStock: "Stoktaki Miktar",
    Manage: "Yönet",
    CreateProduct: "Ürün Oluştur",
    EditProduct: "Ürünü Düzenle",
    AmountUsed: "Kullanılan Miktar",
    Total: "Toplam",
    WarehouseInfo: "Depo Bilgisi",
    DeleteProduct: "Ürünü Sil",
    Cancel: "İptal",
    Select: "Seç",
    Quantity: "Miktar",
    ProductsUsed: "Kullanılan Ürünler",
    NoItemsYet: "Henüz ürün yok",
    Serials: "Seriler",
    NoSerialsAdded: "Hiçbir seri eklenmedi",
    ExtRef: "Harici Referans",
  },
  Department: {
    Users: "Kullanıcılar",
    NoUserAssigned: "Bu departmana henüz kullanıcı atanmadı",
    Departments: "Bölümler",
    Action: "Eylem",
    Edit: "Düzenle",
    Delete: "Sil",
    Name: "İsim",
    Description: "Açıklama",
    Administrative: "Yönetimsel",
    NewDepartment: "Yeni Bölüm",
  },
  Settings: {
    ForwardEmails: "E-postaları Yönlendir",
    Save: "Kaydet",
    CustomerTicketEmails: "Müşteri talep e-postaları",
    CustomerTicketEmailsHint:
      "Müşteri talebi oluşturulduğunda, yanıtlandığında, durumu değiştiğinde veya kapandığında müşteriye e-posta gönderilir ve bir kopyası müşteri talep alıcılarına iletilir. Temsilciler arasında kalan talepler talep şablonlarında kalır.",
    CustomerTicketsRecipients: "Müşteri Talep Alıcıları",
    FirewallRecipients: "Güvenlik Duvarı Alıcıları",
    ItemsRecipients: "Parça Alıcıları",
    ItemReminderRecipients: "Parça Hatırlatıcı Alıcıları",
    FtpRecipients: "FTP Alıcıları",
    SubscriptionsRecipients: "Üyelik Alıcıları",
    TasksRecipients: "Görev Alıcıları",
    TicketsRecipients: "Talep Alıcıları",
    TicketPrintRecipients: "Destek Talebi Yazdırma Alıcıları",
    UsersRecipients: "Kullanıcı Alıcıları",
    VouchersRecipients: "Kupon Alıcıları",
    Enabled: "Etkinleştirildi",
    Host: "Alan Adı",
    Username: "Kullanıcı_Adı",
    Password: "Şifre",
    UploadPath: "Yükleme Yolu",
    UploadPathPlaceholder: "ör: /upload",
    Port: "Port",
    Secure: "Güvenlik?",
    Messages: "Mesajlar",
    Forwards: "Yönlendirmeler",
    Mail: "Posta",
    ConfigurationName: "Yapılandırma Adı",
    EmailSubject: "E-posta Konusu",
    SubjectPlaceholder: "ör: Yeni Destek Talebi [${ticket.id}]",
    FromEmail: "E-posta Adresinden",
    FromEmailPlaceholder: "Varsayılan",
    Forward: "Yönlendir",
    ForwardPlaceholder:
      "E-posta yönlendirme listesindeki alıcılar tarafından alındı...",
    Direct: "Doğrudan",
    DirectPlaceholder: "E-posta hedeflenen alıcı tarafından alındı...",
    AssistantID: "Asistan ID",
    APIKey: "API Anahtarı",
    OrganizationID: "Organizasyon ID",
    Server: "Sunucu",
    Database: "Veritabanı",
    Test: "Test",
    SMTPServerPlaceholder: "smtp.gmail.com",
    SecureConnection: "Güvenli Bağlantı?",
    TestEmail: "E-posta Test Et",
    TestEmailPlaceholder: "ali.orturk@email.com",
    TestMessage: "Test edilecek ileti",
    MessageTestHint:
      "Düzenleyicideki iletiyi gönderir. Yer tutucular örnek verilerle doldurulur ve şablonun etkin olması gerekmez.",
    PrintTemplates: "Baskı Şablonları",
    AvailableTemplates: "Mevcut Şablonlar",
    NoPrintTemplateFound: "Baskı şablonu bulunamadı",
    AddTemplate: "Şablon Ekle",
    View: "Görüntüle",
    PeriodicInventorySync: "Periyodik Envanter Senkronizasyonu",
    SyncInventory: "Stokları Senkronize Et",
    Warehouses: "Depolar",
    NoWarehousesAdded: "Hiç depo eklenmedi",
    Settings: "Ayarlar",
    General: "Genel",
    AddCity: "Şehir Ekle",
    PrintTemplate: {
      Title: "Yazdırma Şablonu",
      Body: "Belgelerin yazdırma düzenini ve biçimini, başlık, altbilgi ve marka öğelerini özelleştirin.",
    },
    Cities: {
      Title: "Şehirler",
      Body: "Uygulama genelinde adreslerde veya konuma bağlı filtrelerde kullanılacak şehir listesini yönetin.",
    },
    Branding: {
      Title: "Markalaşma",
      Body: "Koyu ve açık modlar arasında geçiş yaparak kullanıcı arayüzünün görünümünü ve hissini özelleştirin.",
    },
    Security: {
      Title: "Güvenlik",
      Body: "Erişim iznini kimin alacağını kontrol ederek sisteminizin güvenliğini sağlayın.",
    },
    Logs: {
      Title: "Günlük Dosyaları",
      Body: "Denetim ve sorun giderme için kullanıcı eylemlerinin ve sistem olaylarının geçmişini inceleyin.",
    },
    EmailSetup: "E-posta Kurulumu",
    MailMessageConfiguration: {
      Title: "E-posta Mesaj Yapılandırması",
      Body: "Otomatik ve manuel e-posta iletileri için varsayılan konu, mesaj içeriği ve imzaları tanımlayın.",
    },
    EmailForwarding: {
      Title: "E-posta Yönlendirme",
      Body: "Gelen e-postaların diğer adreslere veya departmanlara yönlendirilmesi için kuralları yapılandırın.",
    },
    Integrations: "Entegrasyonlar",
    SMTP: {
      Title: "SMTP",
      Body: "E-posta işlevselliğini etkinleştirmek için giden e-posta sunucu ayarlarını (sunucu, port ve kimlik bilgileri) yapılandırın.",
    },
    OpenAI: {
      Title: "OpenAI",
      Body: "Yapay zeka destekli özellikleri etkinleştirmek için Assistant ID, API anahtarı ve diğer gerekli parametreleri içeren OpenAI API ayarlarını yapılandırın.",
    },
    FTP: {
      Title: "FTP",
      Body: "Sisteminiz ile harici depolama arasında dosya yüklemek, indirmek veya senkronize etmek için FTP sunucu erişimini yapılandırın.",
    },
    WebhooksAPI: {
      Title: "Webhooks ve API",
      Body: "Harici sistemlerin platformdan gerçek zamanlı veri gönderip alabilmesini sağlamak için webhook'ları ve API erişimini yapılandırın.",
    },
    Import: {
      Title: "İçe Aktarma",
      Body: "Platformlar arasında veri senkronizasyonunu otomatikleştirin",
    },
  },
  ImportSettings: {
    ImportConfiguration: "İçe Aktarma Yapılandırması",
    Save: "Kaydet",
    Model: "Model",
    AutoSync: "Otomatik Senkronizasyon",
    KeyPath: "Anahtar Yolu",
    TargetPath: "Hedef Yolu",
    Url: "URL",
    Headers: "Başlıklar",
    Synchronize: "Senkronize Et",
  },
  TicketPrintTemplate: {
    TicketPrintTemplate: "Destek Talebi Yazdırma Şablonu",
    Add: "Ekle",
    Save: "Kaydet",
    TemplateName: "Şablon Adı",
    Fields: {
      Title: "Alanlar",
      Subtitle: "Yazdırma şablonuna hangi alanların ekleneceğini seçin.",
    },
    Banner: "Afiş",
    Body: "Gövde",
    TicketInfo: "Destek Talebi Bilgisi",
    ID: "Kimlik",
    Title: "Başlık",
    Priority: "Öncelik",
    Department: "Departman",
    Responses: "Yanıtlar",
    ContactInfo: "İletişim Bilgisi",
    Company: "Şirket",
    Person: "Kişi",
    Phone: "Telefon",
    Location: "Konum",
    Assignees: "Atananlar",
    ServiceCallSap: "Servis Çağrısı (SAP)",
    CallID: "Çağrı Kimliği",
    CompanyName: "Şirket Adı",
    ContactName: "İlgili Kişi Adı",
    Task: "Görev",
    Description: "Açıklama",
    TaskAssignees: "Görev Atananlar",
    Comments: "Yorumlar",
    Timelogs: "Zaman günlükleri",
    ItemsUsed: "Kullanılan Ürünler",
    PrintTemplateControls: {
      Title: "Yazdırma Şablonu Kontrolleri",
      Subtitle:
        "Baskı içeriğinin sınırlarını, görünürlüğünü ve biçimlendirmesini ayarlayın.",
    },
    MaxResponses: "Maksimum Yanıt",
    MaxTasks: "Maksimum Görev",
    ForwardEmails: "E-postaları İlet",
    CopyTemplate: "Şablonu Kopyala",
    SignatureRequired: "İmza Zorunlu",
    Themes: {
      Title: "Temalar",
      Subtitle:
        "Marka kimliğinize veya kişisel tercihlerinize uygun renk şemalarını ve stilleri yönetin.",
    },
    BackgroundColor: "Arka Plan Rengi",
    TextColor: "Yazı Rengi",
    SectionTitleColor: "Bölüm Başlık Rengi",
    DisplayTicketUser: "Destek Talebi Kullanıcısını Görüntüle",
    DisplayResponder: "Yanıtlayanı Görüntüle",
    TaskType: "Tür",
    CreateTemplate: "Şablon Oluştur",
  },
  User: {
    Users: "Kullanıcılar",
    Name: "İsim",
    Edit: "Düzenle",
    Role: "Rol",
    Email: "E-posta",
    EmailPlaceholder: "ör: ali.ozturk@email.com",
    Username: "Kullanıcı_Adı",
    FullName: "Tam İsim",
    Company: "Firma",
    Phone: "Telefon",
    NewPassword: "Yeni Şifre",
    EmailConfirmation: "E-posta Doğrulama (Çok Faktörlü Doğrulama)",
    OTP: "Tek Seferlik Şifre (Çok Faktörlü Doğrulama)",
    Action: "Eylem",
    Delete: "Sil",
    NewUser: "Yeni Kullanıcı",
    ExtRef: "Harici Referans",
    ExtRefPlaceholder: "örn. EC33499...",
  },
  Logs: {
    Logs: "Günlük Dosyaları",
    Date: "Tarih",
    Reference: "Referans",
    Ref: "Ref",
    User: "Kullanıcı",
    Model: "Model",
    Action: "Eylem",
  },
  SecurityPage: {
    FirewallRecords: "Güvenlik Duvarı Kayıtları",
    Date: "Tarih",
    IP: "IP",
    Prefix: "Önek Uzunluğu",
    Type: "Tür",
    Action: "Eylem",
    Delete: "Sil",
    NewRecord: "Yeni Kayıt",
  },
  StoragePage: {
    Rename: "Yeniden Adlandır",
    Delete: "Sil",
    FTPStorage: "FTP Depo",
    NewFolder: "Yeni Klasör",
    Path: "Yol",
    Search: "Ara",
    Name: "İsim",
    Date: "Tarih",
    Download: "İndir",
    DownloadConfirm: "Bu dosyayı indirmeye devam etmek istiyor musunuz?",
    Size: "Boyut",
    Unknown: "Bilinmeyen",
    Folder: "Klasör",
    SymbolicLink: "Sembolik Bağlantı",
    NewFile: "Yeni Dosya",
    Edit: "Düzenle",
  },
  FormTemplate: {
    Submit: "Gönder",
    Cancel: "İptal Et",
  },
  ConfirmDialog: {
    Question: "Devam etmek istediğinize emin misiniz?",
    Cancel: "İptal Et",
    Confirm: "Onayla",
  },
  SignatureInput: {
    Signature: "İmza",
    Sign: "İmzala",
  },
  TicketPrintDialog: {
    PrintTicket: "Destek Talebi Yazdır",
    Save: "Kaydet",
    SaveAndSend: "Kaydet ve Gönder",
    Name: "İsim",
    Language: "Dil",
    Template: "Şablon",
    Copy: "Kopya",
    Preview: "Önizleme",
    OriginalPreview: "Orijinal Önizleme",
    CopyPreview: "Kopya Önizleme",
    Signatures: "İmzalar",
    GiverSignature: "Veren Kişinin İmzası",
    ReceiverSignature: "Alan Kişinin İmzası",
    SendToForwardedEmails: "Yönlendirilmiş e-postalara gönderilsin mi?",
    SendCopy: "Kopya gönderilsin mi?",
    CopyEmail: "Kopya E-posta",
  },
  TicketOptionsButton: {
    Print: "Yazdır",
    PrintLog: "Yazdırma Günlüğü",
    Delete: "Sil",
  },
  TicketPrintLogsDialog: {
    PrintLogs: "Yazdırma Kayıtları",
    Delete: "Sil",
    View: "Görüntüle",
    NoPrintLogsFound: "Yazdırma kaydı bulunamadı",
  },
  LanguageSwitcher: {
    Language: "Dil",
    Tooltip: "Dilinizi değiştirmek için buraya tıklayın",
    English: "İngilizce",
    Turkish: "Türkçe",
  },
  DataView: {
    Search: "{{topic}} ara...",
    Filters: "Filtreler",
    Add: "Ekle",
  },
  Enums: {
    Unassigned: "Atanmamış",
    Roles: {
      User: "Kullanıcı",
      Agent: "Temsilci",
      Admin: "Yönetici",
    },
    RecordTypes: {
      Whitelist: "Beyaz Liste",
      Blacklist: "Kara Liste",
    },
    Priorities: {
      Low: "Düşük",
      Medium: "Orta",
      High: "Yüksek",
    },
    Statuses: {
      "Not reviewed": "Gözden geçirilmedi",
      Incomplete: "Tamamlanmadı",
      "Pending confirmation": "Onay Bekliyor",
      Complete: "Tamamlandı",
    },
    ItemType: {
      Invoice: "Fatura",
      Delivery: "Teslimat",
    },
    DateIndicator: {
      Custom: "Gelenek",
      This: "Bu",
      Last: "Son",
    },
    DatePeriod: {
      Day: "Gün",
      Week: "Hafta",
      Month: "Ay",
      Year: "Yıl",
    },
  },
  TextEditor: {
    TypeHere: "Buraya yazın...",
  },
  IntegrationSettingsPage: {
    Title: "Entegrasyon Ayarları",
  },
  ApiSettingsPage: {
    Apis: "API'ler",
    ViewKey: "Anahtarı Görüntüle",
    NewApi: "Yeni API",
    Description: "Açıklama",
    Enabled: "Aktif",
    Disabled: "Etkin Olmayan",
    AssociatedUser: "İlişkili Kullanıcı",
  },
  CreateApiDialog: {
    CreateApi: "API Oluştur",
    Description: "Açıklama",
    DescriptionPlaceholder: "ör: Mobil Uygulama Erişimi",
    User: "Kullanıcı",
    SelectUserPlaceholder: "API anahtarına atamak için bir kullanıcı seçin...",
    AllowedIps: "İzin Verilen IP'ler (virgülle ayrılmış)",
    AllowedIpsPlaceholder: "ör: 192.168.1.1",
    Enabled: "Etkinleştirildi",
  },
  EditApiDialog: {
    AllowedIps: "İzin Verilen IP'ler (virgülle ayrılmış)",
    AllowedIpsPlaceholder: "ör: 192.168.1.1",
    Enabled: "Etkinleştirildi",
    EditApi: "API Düzenle",
    Description: "Açıklama",
    DescriptionPlaceholder: "ör: Mobil Uygulama Erişimi",
    User: "Kullanıcı",
    SelectUserPlaceholder: "API anahtarına atamak için bir kullanıcı seçin...",
    ApiKey: "API Anahtarı",
    Copy: "Kopyala",
    Delete: "Sil",
  },
  Api: {
    AllowedIps: "İzin Verilen IP'ler",
    AssociatedUser: "İlişkili Kullanıcı",
    Enabled: "Etkinleştirildi",
    Disabled: "Etkin Olmayan",
    Description: "Açıklama",
    Key: "Anahtar",
  },
  WebhookSettingsPage: {
    Webhooks: "Webhook'lar",
    NewWebhook: "Yeni Webhook",
    Description: "Açıklama",
    Enabled: "Aktif",
    Disabled: "Etkin Olmayan",
    Url: "URL",
  },
  WebhookForm: {
    CreateWebhook: "Webhook Oluştur",
    EditWebhook: "Webhook Düzenle",
    Description: "Açıklama",
    DescriptionPlaceholder: "ör: Destek Talebi Oluşturuldu Webhook'u",
    Url: "URL",
    UrlPlaceholder: "ör: https://webhook.site/unique-webhook-url",
    Enabled: "Etkinleştirildi",
    Delete: "Sil",
    ViewConfigurations: "Yapılandırmaları Görüntüle",
    ViewLogs: "Günlükleri Görüntüle",
  },
  WebhookEventSelect: {
    SelectEvent: "Olay Seç",
    DepartmentEvents: "Bölüm Olayları",
    TicketEvents: "Destek Talebi Olayları",
    UserEvents: "Kullanıcı Olayları",
    FileEvents: "Dosya Olayları",
    TaskEvents: "Görev Olayları",
    FirewallEvents: "Güvenlik Duvarı Olayları",
    Ticket: {
      TicketCreated: "Destek Talebi Oluşturuldu",
      TicketUpdated: "Destek Talebi Güncellendi",
      TicketDeleted: "Destek Talebi Silindi",
      TicketResponseCreated: "Destek Talebi Yanıtı Oluşturuldu",
      TicketResponseUpdated: "Destek Talebi Yanıtı Güncellendi",
      TicketResponseDeleted: "Destek Talebi Yanıtı Silindi",
      TicketAssigneeAdded: "Destek Talebi Atanan Kişi Eklendi",
      TicketAssigneeRemoved: "Destek Talebi Atanan Kişi Çıkarıldı",
      TicketDetailsUpdated: "Destek Talebi Detayları Güncellendi",
    },
    User: {
      UserCreated: "Kullanıcı Oluşturuldu",
      UserRegistered: "Kullanıcı Kaydoldu",
      UserUpdated: "Kullanıcı Güncellendi",
      UserDeleted: "Kullanıcı Silindi",
    },
    File: {
      FileUploaded: "Dosya Yüklendi",
      FileDeleted: "Dosya Silindi",
      FileDirectoryCreated: "Dosya Dizini Oluşturuldu",
      FileDirectoryDeleted: "Dosya Dizini Silindi",
    },
    Task: {
      TaskCreated: "Görev Oluşturuldu",
      TaskUpdated: "Görev Güncellendi",
      TaskDeleted: "Görev Silindi",
      TaskTimelogCreated: "Görev Zaman Kaydı Oluşturuldu",
      TaskTimelogUpdated: "Görev Zaman Kaydı Güncellendi",
      TaskTimelogDeleted: "Görev Zaman Kaydı Silindi",
      TaskUserAssigned: "Görev Kullanıcısı Atandı",
      TaskUserUnassigned: "Görev Kullanıcısı Atandı",
      TaskProductsAdded: "Görev Ürünleri Eklendi",
      TaskProductsDeleted: "Görev Ürünleri Çıkarıldı",
      TaskProductsSerialsUpdated: "Görev Ürünleri Seri Numaraları Güncellendi",
      TaskStatusUpdated: "Görev Durumu Güncellendi",
    },
    Firewall: {
      FirewallRecordCreated: "Güvenlik Duvarı Kaydı Oluşturuldu",
      FirewallRecordUpdated: "Güvenlik Duvarı Kaydı Güncellendi",
      FirewallRecordDeleted: "Güvenlik Duvarı Kaydı Silindi",
    },
    Department: {
      DepartmentCreated: "Bölüm Oluşturuldu",
      DepartmentUpdated: "Bölüm Güncellendi",
      DepartmentDeleted: "Bölüm Silindi",
    },
  },
  HttpHeaderList: {
    HttpHeaders: "HTTP Başlıkları",
    AddHeader: "Başlık Ekle",
    HeaderName: "Başlık Adı",
    HeaderValue: "Başlık Değeri",
  },
  WebhookLogs: {
    Date: "Tarih",
    Status: "Durum",
    ResponseCode: "Yanıt Kodu",
    Url: "URL",
    Payload: "Yük",
    ViewPayload: "Yükü Görüntüle",
    WebhookLogs: "Webhook Günlükleri",
    Response: "Yanıt",
  },
  Branding: {
    Address: "Adres",
    Phone: "Telefon",
    Email: "E-posta",
    WebsiteLabel: "Web Sitesi Etiketi",
    WebsiteLink: "Web Sitesi",
    BrandingSettings: "Markalaşma Ayarları",
    Branding: "Markalaşma",
    Image: "Görüntü",
    Logo: "Logo",
    Link: "Bağlantı",
    MapEmbed: "Harita Gömme",
    Name: "İsim",
    Shortname: "Kısa İsim",
    ThemeColor: "Tema Rengi",
    UploadLogo: "Logoyu Yükle",
    WhatsappLabel: "WhatsApp Etiketi",
    WhatsappNumber: "Whatsapp Numarası",
    LinkedinLabel: "Linkedin Etiketi",
    LinkedinLink: "Linkedin Bağlantısı",
    XLabel: "X (Twitter) Etiketi",
    XLink: "X (Twitter) Bağlantısı",
    InstagramLabel: "Instagram Etiketi",
    InstagramLink: "Instagram Bağlantısı",
    FacebookLabel: "Facebook Etiketi",
    FacebookLink: "Facebook Bağlantısı",
    YoutubeLabel: "Youtube Etiketi",
    YoutubeLink: "Youtube Bağlantısı",
    LogoLink: "Logo Bağlantısı",
    Domain: "Alan Adı",
    Contacts: "İletişimler",
    Links: "Bağlantılar",
    Favicon: "Favicon",
    Title: "Başlık",
    Description: "Açıklama",
    WhatWeDo: "Ne yapıyoruz",
  },
  FaviconInput: {
    Change: "Değiştir",
    ClickToUpload: "Görüntünüzü yüklemek için buraya tıklayın",
    ImgSupported: "Desteklenen formatlar: ICO",
  },
  FilterViews: {
    FilterView: "Filtre Görünümü",
    DefaultView: "Varsayılan görünüm",
    SaveView: "Görünümü Kaydet",
    New: "Yeni",
    Save: "Kaydet",
    Delete: "Sil",
    Name: "İsim",
  },
};
